function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st1f{fill:#31D055;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1f",
  d: "M74.74,35.1H70.2v-8.15c0-1.96-1.59-3.55-3.55-3.55H62.4v-3.14l-0.64-0.64c0,0,0,0,0,0l-9.48-9.48L42.14,0 H10.4v14.3H3.55C1.59,14.3,0,15.89,0,17.85v56.79h0.01C0,75.38,0.23,76.09,0.69,76.69C1.32,77.52,2.29,78,3.33,78h58.19 c1.5,0,2.83-1.01,3.19-2.36L78,39.19v-0.23C78,36.72,76.63,35.1,74.74,35.1z M66.65,26c0.52,0,0.95,0.43,0.95,0.95v8.15h-5.2V26 H66.65z M42.9,4.44L57.96,19.5H42.9V4.44z M13,2.6h27.3v19.5h19.5v1.3v11.7H16.55c-0.19,0-0.37,0.02-0.55,0.05 c-1.27,0.21-2.32,1.13-2.64,2.31l-0.37,1V14.3V2.6z M2.6,17.85c0-0.53,0.43-0.95,0.95-0.95h6.85v28.65L2.6,66.82V17.85z  M62.23,74.86c-0.09,0.32-0.38,0.54-0.71,0.54H3.33c-0.32,0-0.5-0.18-0.58-0.29C2.67,75,2.54,74.78,2.59,74.58l7.81-21.41v0.01 l5.41-14.83l0.03-0.11c0.09-0.32,0.38-0.54,0.71-0.54H59.8h2.6h7.8h4.54c0.49,0,0.62,0.71,0.65,1.06L62.23,74.86z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1f",
  d: "M20.8,22.1h13c0.72,0,1.3-0.58,1.3-1.3c0-0.72-0.58-1.3-1.3-1.3h-13c-0.72,0-1.3,0.58-1.3,1.3 C19.5,21.52,20.08,22.1,20.8,22.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1f",
  d: "M20.8,13h13c0.72,0,1.3-0.58,1.3-1.3s-0.58-1.3-1.3-1.3h-13c-0.72,0-1.3,0.58-1.3,1.3S20.08,13,20.8,13z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1f",
  d: "M20.8,31.2H52c0.72,0,1.3-0.58,1.3-1.3c0-0.72-0.58-1.3-1.3-1.3H20.8c-0.72,0-1.3,0.58-1.3,1.3 C19.5,30.62,20.08,31.2,20.8,31.2z"
}));

var SvgFolder = function SvgFolder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 78 78",
    style: {
      enableBackground: "new 0 0 78 78"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Folder.10dbd4e4.svg";
export { ForwardRef as ReactComponent };